import React, { Component } from "react";
import { Link } from 'react-router-dom';
import $ from 'jquery';
import {menuOpen, sideMenuOpen, sideMenuClose, MENU_ITEMS , CONFIG} from '../helpers/Common'
 
class Menu extends Component {
  constructor(props)
  {
    super(props);
    this.logOut           = this.logOut.bind(this);
  }
  componentDidMount()
  {
    $(function () {
        $('body').on('click', '.nav-icon', function () {
            menuOpen();
        }).on('click', '.js-sideMenu:not(.is--active)', function () {
            sideMenuOpen();
        }).on('click', '.js-sideMenu.is--active', function () {
            sideMenuClose();
        }).on('click', '.js-sideMenu-close', function () {
            sideMenuClose();
        }).on('click touchstart', '.js-defaultOverlay', function () {
            sideMenuClose();
        });
        $('body').removeClass('is--menu')
    });
  }
  logOut = ()=>{
    localStorage.removeItem('userData');
    window.location.reload();
  }
  render() {
    return (
        <React.Fragment>
        <div className="c-side-nav">
            <div className="bg-side-overlay"></div>
            <a href="javascript:;" className="btnBack js-sideMenu-close">
                <img src="assets/img/icons/ic-close.svg" alt="" className="tosvg" />
                <span>{CONFIG.Close}</span>
            </a>
            <div className="c-side-menu">
                <div className="c-menuWrapper">
                    <ul className="c-menuList">
                        <li>
                            <Link to="/surgeon/patients">
                                <span>{MENU_ITEMS.Pending_Narratives}</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/surgeon/approved">
                                <span>{MENU_ITEMS.approved_narratives}</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/surgeon/profile/">
                                <span>{MENU_ITEMS.My_Profile}</span>
                            </Link>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <span>{MENU_ITEMS.Settings}</span>
                            </a>
                        </li>
                        <li onClick={this.logOut}>
                            <a href="javascript:;">
                                <span>{MENU_ITEMS.Logout}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="defaultOverlay js-defaultOverlay"></div>
        </React.Fragment>
    );
  }
}

export default Menu;
